import _ from 'lodash';

function findPrimaryOrFirst(items = []) {
  return _.find(items, { is_primary: true }) || _.first(items) || {};
}

export default findPrimaryOrFirst;
